import createReactComponent from '../createReactComponent';
var Cloud = createReactComponent('Cloud', [['path', {
  d: 'M17.5 19a4.5 4.5 0 100-9h-1.8A7 7 0 109 19h8.5z',
  key: '1ur2jr'
}]]);
export default Cloud;